export const STATE_NAME = 'Home';
